export let life = {
  mounted () {
  }
}
export let event = {
  renderHeader(createElement, { column, _self }) { 
    const label = column.label 
    const labelArr = label.split(' ') 
    if(column.property==='titleName'){
      return createElement( 
        'span',     //创建最外层的标签可随意
        [ 
            createElement('span', {  // 创建第一个元素的标签可随意
            attrs: { type: 'text',style: 'font-size:20px' } 
            },[labelArr[0]] ), 
        ]
      ) 
    }else{
      return createElement( 
        'span',     //创建最外层的标签可随意
          [ 
            createElement('span', {  // 创建第一个元素的标签可随意
            attrs: { type: 'text',style: 'font-size:15px' } 
            },[labelArr[0]] ), 
          ]
      ) 
    }
  }
}
export let watch = {}
